/*=========================================================================================
  File Name: moduleDeviceGetters.js
  Description: Device Module Getters
==========================================================================================*/


export default {
    getDevice: state => state.device,
}
